import { Navigate } from "react-router-dom";
import { useLocation } from "react-router";
import NavigationScroll from "layout/navigationScroll";
import ROUTE_NAMES from "./routeNames";

const PublicRoute = ({ children }: any) => {
  const token = sessionStorage.getItem("token");
  const location = useLocation();
  if (token) {
    return (
      <Navigate
        to={ROUTE_NAMES.MAIN_ROUTES.DASHBOARD}
        state={{ from: location }}
      />
    );
  }
  return <NavigationScroll>{children}</NavigationScroll>;
};
export default PublicRoute;
